/**
 * @generated SignedSource<<7d9a50f86e9a802d12e769132aa92eee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type acquisitionConfigAppConfigQuery$variables = Record<PropertyKey, never>;
export type acquisitionConfigAppConfigQuery$data = {
  readonly appConfig: {
    readonly json: unknown | null | undefined;
  } | null | undefined;
};
export type acquisitionConfigAppConfigQuery = {
  response: acquisitionConfigAppConfigQuery$data;
  variables: acquisitionConfigAppConfigQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "entityId": "acquisition"
        }
      }
    ],
    "concreteType": "AppConfigs",
    "kind": "LinkedField",
    "name": "appConfig",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "json",
        "storageKey": null
      }
    ],
    "storageKey": "appConfig(filter:{\"entityId\":\"acquisition\"})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "acquisitionConfigAppConfigQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "acquisitionConfigAppConfigQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ae145e45f59aec55d9ed0937d247e322",
    "id": null,
    "metadata": {},
    "name": "acquisitionConfigAppConfigQuery",
    "operationKind": "query",
    "text": "query acquisitionConfigAppConfigQuery {\n  appConfig(filter: {entityId: \"acquisition\"}) {\n    json\n  }\n}\n"
  }
};
})();

(node as any).hash = "7b6d1aadebb4a707abaf178b27e5716e";

export default node;
